export const getAllData = async (action) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: action, apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin})
    });
    return await response.json();
};
